// extracted by mini-css-extract-plugin
module.exports = {"container":"_b73d667","mobileClickFeedback":"_23f13ff","loading":"_c1756fe","topWidgets":"_699781c","layoutSwitch":"_bfc297e","clubsContainer":"_9cdf573"};